import React from "react";
import { Form, Input, Button, Card, message, Typography } from "antd";
import { Mail, Lock, UserPlus } from "lucide-react";
import { useNavigate, Link, useSearchParams } from "react-router-dom";
import useUserStore from "../store/userStore";
import { useTranslation } from "../i18n/useTranslation";

const { Title, Text } = Typography;

const Login = () => {
  const navigate = useNavigate();
  const { login, isLoading, error, clearError } = useUserStore();
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const [searchParams] = useSearchParams();
  const redirectUrl = searchParams.get("redirect") || "/";

  // 组件加载时清除错误状态
  React.useEffect(() => {
    clearError();
  }, [clearError]);

  const onFinish = async (values) => {
    const { email, password } = values;
    const result = await login(email, password);
    if (result.success) {
      message.success(t("loginSuccess"));
      navigate(redirectUrl);
    } else {
      message.error(result.error);
    }
  };

  return (
    <div
      key="login"
      className="min-h-screen flex items-center justify-center bg-gray-50 p-4"
    >
      <Card className="w-full max-w-md shadow-lg" bordered={false}>
        <div className="text-center mb-6">
          <Title level={3} className="mb-2">
            {t("loginWelcomeTitle")}
          </Title>
          <Text type="secondary">{t("loginWelcomeSubtitle")}</Text>
        </div>

        <Form
          form={form}
          name="login"
          layout="vertical"
          onFinish={onFinish}
          initialValues={{ remember: true }}
        >
          <Form.Item
            name="email"
            label={t("loginEmailLabel")}
            rules={[
              { required: true, message: t("loginEmailRequired") },
              { type: "email", message: t("loginEmailInvalid") },
            ]}
          >
            <Input
              prefix={<Mail className="text-gray-400" size={16} />}
              placeholder={t("loginEmailPlaceholder")}
              className="h-11"
            />
          </Form.Item>

          <Form.Item
            name="password"
            label={t("loginPasswordLabel")}
            rules={[
              { required: true, message: t("loginPasswordRequired") },
              { min: 6, message: t("loginPasswordMinLength") },
            ]}
          >
            <Input.Password
              prefix={<Lock className="text-gray-400" size={16} />}
              placeholder={t("loginPasswordPlaceholder")}
              className="h-11"
              visibilityToggle
            />
          </Form.Item>

          <Form.Item className="mb-6">
            <Button
              type="primary"
              htmlType="submit"
              className="w-full h-11 text-base"
              loading={isLoading}
              size="large"
            >
              {t("loginButton")}
            </Button>
          </Form.Item>

          <div className="text-center">
            <Text type="secondary" className="flex items-center justify-center">
              {t("loginNoAccount")}
              <Link
                to="/register"
                className="text-blue-600 hover:text-blue-800 font-medium flex items-center"
              >
                <UserPlus size={14} className="inline mr-1" /> {t("loginRegisterNow")}
              </Link>
            </Text>
          </div>
        </Form>
      </Card>
    </div>
  );
};

export default Login;
